import { render, staticRenderFns } from "./newsdetail.vue?vue&type=template&id=105568d2&scoped=true&"
import script from "./newsdetail.vue?vue&type=script&lang=js&"
export * from "./newsdetail.vue?vue&type=script&lang=js&"
import style0 from "./newsdetail.vue?vue&type=style&index=0&id=105568d2&lang=scss&scoped=true&"
import style1 from "./newsdetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105568d2",
  null
  
)

export default component.exports